// Function loadCollageImageGridItemBlock loads the CollageImageGridItemBlock class by dynamically importing the js on demand if needed

export function loadShopFeaturedGridItemBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-shop-featured-grid-item-block-chunk" */ '../widgets/shopFeaturedGridItemBlock').then(wg => {

		const { ShopFeaturedGridItemBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ShopFeaturedGridItemBlock"]');

		if(!$wg) {
			// console.info('ShopFeaturedGridItemBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ShopFeaturedGridItemBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ShopFeaturedGridItemBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ShopFeaturedGridItemBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ShopFeaturedGridItemBlock widget');

}
